import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { FiCalendar } from "react-icons/fi";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip);

export default function LeadsBySource() {
  const [filter, setFilter] = useState("This Week");

  const chartDataMap = {
    Today: [20, 25, 30, 25],
    "This Week": [40, 35, 15, 10],
    Month: [50, 20, 20, 10],
    Year: [60, 15, 15, 10],
  };

  const labels = ["Google", "Paid", "Campaigns", "Referrals"];
  const values = chartDataMap[filter];

  const colors = ["#0f4c5c", "#fbbf24", "#ec4899", "#8b5cf6"];

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderWidth: 0,
        hoverOffset: 4,
      },
    ],
  };

  // Center text plugin
  const centerText = {
    id: "centerText",
    beforeDraw(chart) {
      const { width } = chart;
      const { height } = chart;
      const ctx = chart.ctx;

      ctx.restore();

      const activeIndex = chart.getActiveElements()?.[0]?.index ?? 0;

      const text = labels[activeIndex];
      const value = values[activeIndex] + "%";

      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      ctx.font = "16px sans-serif";
      ctx.fillStyle = "#1f2937";
      ctx.fillText(text, width / 2, height / 2 - 10);

      ctx.font = "22px bold sans-serif";
      ctx.fillText(value, width / 2, height / 2 + 15);

      ctx.save();
    },
  };

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#0f4c5c",
        padding: 10,
        displayColors: false,
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
    },
    cutout: "70%",
  };

  return (
    <Card className="h-100 task-card" style={styles.card}>
      {/* Header */}
      <div className="card-header-custom" style={styles.header}>
        <h5 style={styles.title}>Leads by Source</h5>

        <Dropdown>
          <Dropdown.Toggle style={styles.filterBtn} size="sm">
            <FiCalendar style={{ marginRight: 5 }} />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {["Today", "This Week", "Month", "Year"].map((item) => (
              <Dropdown.Item
                key={item}
                active={filter === item}
                onClick={() => setFilter(item)}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Chart */}
      <div style={{ width: "220px", margin: "0 auto" }}>
        <Doughnut
          data={data}
          options={options}
          plugins={[centerText]}
        />
      </div>

      {/* Legend */}
      <div style={{ marginTop: 20 }}>
        <strong>Status</strong>

        {labels.map((name, i) => (
          <div key={i} style={styles.legendRow}>
            <div style={styles.legendLeft}>
              <span
                style={{
                  ...styles.dot,
                  backgroundColor: colors[i],
                }}
              ></span>
              {name}
            </div>
            <span>{values[i]}%</span>
          </div>
        ))}
      </div>
      <style>
          {
               `     .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:12px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
@media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
               
               `
          }
      </style>
    </Card>
  );
}

/* ✅ INTERNAL CSS */
const styles = {
  card: {
    padding: 16,
    borderRadius: 5,
    border: "2px solid #e5e7eb",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },

  title: {
    margin: 0,
    fontWeight: 600,
  },

  filterBtn: {
    background: "#fff",
    border: "1px solid #ddd",
    fontSize: 13,
    color: "#333",
  },

  legendRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10,
    fontSize: 14,
  },

  legendLeft: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },

  dot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
  },
};